/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerModel { 
    customerNumber?: string | null;
    customerName?: string | null;
    customerClass?: string | null;
    locationId?: number;
    locationIdentifier?: string | null;
    salesPersonId?: string | null;
    nationalAccountNumber?: string | null;
    customerCity?: string | null;
    customerState?: string | null;
    customerZipCode?: string | null;
}

